<template>
    <b-modal
        id="ModalInstallationSpecs"
        title="Spécifications techniques de l'installation"
        size="xl"
        header-bg-variant="kalkin-1"
        header-text-variant="light"
        hide-footer
    >
        <FormInstallationSpecs
            :project-id="projectId"
            :installation="installation"
            @saved="onSaved"
            class="mb-2"
        />
    </b-modal>
</template>
<script>
import FormInstallationSpecs from "@/components/model/installation/FormInstallationSpecs";
export default {
    components: {
        FormInstallationSpecs,
    },

    props: {
        projectId: { type: [String, Number], required: true },
        installation: { type: Object, required: true },
    },

    methods: {
        onSaved() {
            this.$bvModal.hide("ModalInstallationSpecs");
            this.$emit("saved");
        },
    },
};
</script>
